<template>
    <Resize id="app" class="app-layout" :mobile="mobile" :class="{about:isAbout}" :mobMenuShow="mobMenuShow">
        <header-app></header-app>
        <div class="background-container">
            <div class="bg-center valign">
                <Spiral></Spiral>
            </div>
            <div class="bg-bottom" :class="{hide:isHidden, strong:isStrong}">
                <!--<p class="mobile-hidden">-->
                    <!--<span class="text__big">БАД, НЕ ЯВЛЯЕТСЯ ЛЕКАРСТВЕННЫМ СРЕДСТВОМ</span>-->
                    <!--<span class="text__middle">ИМЕЮТСЯ ПРОТИВОПОКАЗАНИЯ. ПЕРЕД ПРИМЕНЕНИЕМ НЕОБХОДИМО ПРОКОНСУЛЬТИРОВАТЬСЯ С ВРАЧОМ</span>-->
                    <!--<span class="text__small">производитель ООО «Крафт», 197022, г. Санкт-Петербург, пр. Медиков, д. 5, лит. В, пом. 7-Н. Адрес производства: 188679, Ленинградская обл., Всеволожский р-н, пос. им. Морозова на площадях Опытного завода ФГУП РНЦ «Прикладная химия», цех 206, корпус 102,209.-->
            <!--Маркетинг и дистрибьюция: ОАО «Нижфарм», Россия, 603950, г. Нижний Новгород, ГСП - 459, ул. Салганская, д. 7, тел. +7 (831) 278-80-88, факс: +7 (831) 430-72-13. Свидетельство о государственной регистрации: № RU.77.99.88.003.E.010166.11.14 от 05.11.2014 г.</span>-->
                <!--</p>-->
                <p class="mobile-hidden">* Шендеров Б.А. Метабиотики: новая идея или естественное развитие пробиотической концепции:
                    Материалы симпозиума «Современное состояние и перспективы развития концепции пробиотикотерапии».</p>
                <p :class="{hidden:!isAbout}">** Инструкция по применению БАКТИСТАТИН®</p>
                <p>Москва, 30.09.2013.  СГР № RU.77.99.88.003. E.010166.11.14 от 05.11.2014 г. </p>
                <p>АО «НИЖФАРМ» 119017, Москва, ул. Большая Ордынка, 44с4</p>
                <DiscD class="mobile-hidden"></DiscD>
                <Disc class="desktop-hidden"></Disc>
            </div>
        </div>

        <transition name="fades">
            <router-view v-if="!mobMenuShow"></router-view>
        </transition>

        <main-nav :mobMenuShow="mobMenuShow" :mobMenuToggle="mobMenuToggle" :mobile="mobile"></main-nav>

        <div v-if="mobile" class="rotate-message valign desktop-hidden">
            <img src="/static/images/rotate.png" alt="Rotate">
            <p>Пожалуйста, переверните устройство</p>
        </div>

        <footer-app></footer-app>
    </Resize>
</template>

<script>

    import Helpers from '@/tools/Helpers';

    import Resize from '@/components/common/Resize';

    import Menu from '@/components/common/Menu';

    import Header from '@/components/parts/Header';

    import MainNav from '@/components/common/MainNav';

    import Footer from '@/components/parts/Footer';

    import Logo from './assets/svg/logo.svg';

    import Spiral from './assets/svg/spiral.svg';

    import Disc from './assets/svg/disc.svg';

    import DiscD from './assets/svg/legal.svg';



    export default {
        name: 'app',

        data () {
            return {
                pageIndex: 0,
                canHandle: true,
                mobile: false,
                mobMenuShow: false,
            }
        },

        components: {
            Logo,
            Resize,
            Spiral,
            Disc,
            DiscD,
            'menu-app': Menu,
            'header-app': Header,
            'footer-app': Footer,
            'main-nav': MainNav
        },
        mounted () {
            let self = this;

            self.isMobile();
            window.addEventListener('resize', function() {
                self.isMobile();
            });

            ga('send', 'event', 'load', 'show', 'Home page loaded');

//            var lay1 = document.querySelector('.layer__1');
//            var lay2 = document.querySelector('.layer__2');
//            document.body.addEventListener('mousemove',function(e){
//                lay1.style.transform = 'rotate('+e.clientX/1000+'deg)';
//                lay2.style.transform = 'rotate('+e.clientY/1000+'deg)';
//            })

        },
        computed: {
            isHidden () {
                let self = this;
                switch (this.$route.name) {
                    case 'Recipes':
                        return true;
                    case 'Recipe':
                        return true;
                    default:
                        return false;
                }
            },
            isStrong () {
                let self = this;
                switch (this.$route.name) {
                    case 'TestStart':
                        return true;
                    case 'TestMain':
                        return true;
                    default:
                        return false;
                }
            },
            isAbout(){
                let self = this;
                switch (this.$route.name) {
                    case 'About':
                        return true;
                }
            }
        },
        methods: {
            isMobile () {
                let classList = document.body.classList;
                let mClassName = 'mobile';
                let self = this;

                if(Helpers.isMobile()) {
                    classList.add(mClassName);
                    self.mobile = true;
                } else {
                    classList.remove(mClassName);
                    self.mobile = false;
                }
            },

            is_touch_device: function () {
                var isMobile = false; //initiate as false
// device detection
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;
                return isMobile;
            },

            mobMenuToggle: function(event){
                let self = this;
                self.mobMenuShow = !self.mobMenuShow;
                if(event.currentTarget.classList.contains('mobile-menu-btn') && self.mobMenuShow == true){
                    ga('send', 'event', 'click', 'show', 'Mobile Menu Show');
                }
                if(event.currentTarget.classList.contains('menu-link')){
                    ga('send', 'event', 'click', 'show', 'Go from mobile menu to: ' + event.currentTarget.getAttribute('href'));
                }
                return self.mobMenuShow;
            }



        }
    }
</script>

<style>
    .fades-enter-active {
        transition: .2s  all .2s ease;
    }
    .fades-leave-active {
        transition: all .2s ease;
    }
    .fades-enter, .fades-leave-to{
        opacity: 0;
    }
</style>




// WEBPACK FOOTER //
// App.vue?5cdf9fb9